import React from 'react';

import { useTranslation } from 'providers/GILT.provider';

const TooltipNewClient = () => {
  const { t } = useTranslation();

  return (
    <div className="info-tooltip" data-bem="TooltipNewClient">
      <i>{t('clientConnect.tooltipGuide')}</i>
      <div className="client-info-icon">
        <span className="tooltip">
          <div className="tooltip-centered">{t('clientConnect.newClientTooltipText')}</div>
        </span>
      </div>
    </div>
  );
};

export default TooltipNewClient;
